export default __webpack_public_path__ + "static/media/Gaegu-Bold.a9a48e93.ttf";